import { useRef } from "react";
import webContextProvider from "../../../../providers/webContextProvider";
import InformationIcon from "../InformationIcon";
import PropTypes from "prop-types";
import OriginalPrice from "../OriginalPrice";
import openSitechromeModal from "../openSitechromeModal";
import getSitechromeModalUrl from "../getSitechromeModalUrl";
import getPricingModalContentTemplate from "../getPricingModalContentTemplate";
import formatDate from "./formatDate";
import formatPrice from "../formatPrice";

const OriginalPriceInformationIcon = ({
  originalPrice,
  isOutlet,
  previousEndDate
}) => {
  const ref = useRef(null);

  const handleClick = e => {
    e.preventDefault();

    const { browseLanguage: lang } = webContextProvider();
    const contentTemplate = getPricingModalContentTemplate({ isOutlet });
    const date = formatDate(previousEndDate, lang);
    const baseUrl = "/web/pages/simple-modal/index.html";
    const modalUrl = getSitechromeModalUrl({
      baseUrl,
      additionalParams: {
        lang,
        contentTemplate,
        price: formatPrice(originalPrice),
        date
      }
    });

    openSitechromeModal({ url: modalUrl, focusOnCloseElement: ref.current });
  };

  return (
    <InformationIcon
      onClick={handleClick}
      ref={ref}
      ariaLabel="More Pricing Information"
    >
      <OriginalPrice originalPrice={originalPrice} isOutlet={isOutlet} />
    </InformationIcon>
  );
};

OriginalPriceInformationIcon.propTypes = {
  originalPrice: PropTypes.number,
  isOutlet: PropTypes.bool.isRequired,
  previousEndDate: PropTypes.string
};

export default OriginalPriceInformationIcon;
